import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Theme,
} from "@mui/material";
import { Field } from "../../utils/formSchema";
import CustomInputButton from "../../components/Input/customInputButton";
import DamsTable from "../../components/Table/CollapsibleTable";
import { TRowItem } from "../../components/Table/TableRow";
import { useMangeTableItems } from "../../hooks/useManageTableItems";
import { usePagination } from "../../hooks/usePagination";

import { ContainedButton, TextButton } from "../../components/Button/AppButton";
import { IPagination, Roles,  } from "../../config/types";
import { rolesApi } from "../../services/roles";

interface InputProps {
  placeholder: string;
  label: string;
  handleChange: (item: Field,roleName?:string) => void;
  value?: string;
  size?: "full" | "short" | "long";
  error?: boolean;
  errorMessage?: string;
}


export const UserRoleSelectInput = ({
  placeholder,
  handleChange,
  label,
  error,
  value,
  size = "full",
  errorMessage = "required",
}: InputProps) => {
  const [dataset, setDataset] = useState<TRowItem[]>([]);
  const [selectName, setSelectName] = useState("");
  const [loading, setLoading] = useState(true);
  const { selectedRowItems, toggleRow } = useMangeTableItems(dataset, false);
  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState,
  } = usePagination<any>(rolesApi.getRoles);


 
     const populateDataSet=( data: Roles[],pagination?:IPagination)=>{
       const formatData = (data).map((data) => ({
         ...data,
   
         permissions:
           data.permissions? data.permissions.map(
                 (item) => ` ${item.name} `
               ) : []}));
       setDataset(formatData);
       updatePaginationInitState(pagination);
     }
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
        const res = await rolesApi.getRoles();
      if (res.data) {
        populateDataSet(res.data, res.pagination);
        if (value) {
          const __default = (await rolesApi.getRole(value))
            .data;
          if (__default) {
            setSelectName(`${__default.name}`);
            handleChange({ value: __default.id, isValid: true },__default.name);
            toggleRow(__default as TRowItem);
          }
        }
      }
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [open, setOpen] = React.useState(false);
  const toggleModel = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleUserResponse = (row: TRowItem) => {
    const response = toggleRow(row);
    if (response && response.isSelected) {
      handleChange({
        value: row?.id ?? "",
        isValid: row?.id ? true : false,
      },row?.name);
      setSelectName(`${row.name}`);
      handleClose();
    }
  };
 
  return (
    <Box>
      <CustomInputButton
        loading={loading}
        label={label}
        placeholder={placeholder}
        value={selectName}
        handleChange={toggleModel}
        error={error}
        errorMessage={errorMessage}
        size={size}
      />
      <Dialog
        maxWidth={"xl"}
        open={open}
        sx={{ height: "100%" }}
        onClose={toggleModel}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          paddingRight={2}
        >
          <DialogTitle fontWeight={600}>{"User Roles"}</DialogTitle>
          {value === "" ? (
            <Box marginTop={2}>
              <TextButton title="Continue" />
            </Box>
          ) : (
            <DialogActions>
              <ContainedButton onClick={handleClose} title="Continue" />
            </DialogActions>
          )}
        </Stack>

        <DialogContent sx={styles.content}>
      

          <DamsTable
            isModel
            tableHeaders={columns}
            hiddenKeys={hkeys}
            hiddenLabels={hcolumns}
            tableKeys={tkeys}
            data={dataset}
            hasHeaderCheckBox={false}
            hasPagination
            paginationState={pagination}
            onNextPage={paginateToNextPage({}, populateDataSet)}
            onPreviousPage={paginateToPreviousPage({}, populateDataSet)}
            setActivePage={paginateToPageNumber(populateDataSet, {})}
            useTableCheckbox
            onTableItemSelect={handleUserResponse}
            selectedRowItems={selectedRowItems}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

const styles = {
  filterBox: {
    width: "100%",
    marginBottom: 5,
  },
  content: (theme: Theme) => ({
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.up("xl")]: {
      width: "70vw",
    },
    width: "90vw",
  }),
  table: {
    width: "100vw",
    height: "70%",
  },
};



const tkeys = ["name", "permissions_count", "created_at"];

const columns = ["Role Name", "No. of Permissions", "Date Added"];

const hkeys = ["permissions",];

const hcolumns = ["Permissions",];
